/**
 * JalaIcon icon set component.
 * Usage: <JalaIcon name="icon-name" size={20} color="#4F8EF7" />
 */

import createIconFromFontello from 'react-native-vector-icons/lib/create-icon-set-from-fontello';
import config from './fontello/config.json';

export const JalaIcon = createIconFromFontello(config, undefined, 'JalaIcon.ttf');
